import { TemplateResult, html } from 'lit';

import { dateShort } from '../../common/utils/formatDate';
import {
  formatDecimalAsPercentage,
  abbreviateNumberToCurrency,
} from '../../common/utils/formatNumber';
import { KeyFact, KeyFactWithRank, ValueFormat } from './key-fact.model';
import { toStars } from '../../common/utils/textFormat';

export function isKeyFactWithRank(
  keyFact: KeyFact,
): keyFact is KeyFactWithRank {
  if (keyFact.rank && Number.isInteger(parseInt(keyFact.rank))) {
    return true;
  }

  return false;
}

export function formatKeyFactValue(
  value: string,
  valueFormat?: string,
): string {
  if (valueFormat) {
    if (valueFormat === ValueFormat.percentage) {
      return formatDecimalAsPercentage(Number(value), 2);
    }
    if (valueFormat === ValueFormat.USD) {
      if (Number(value) < 1000) {
        return abbreviateNumberToCurrency(Number(value), valueFormat, 2);
      } else {
        return abbreviateNumberToCurrency(Number(value), valueFormat, 1);
      }
    }
    if (valueFormat === ValueFormat.date) {
      return dateShort(value);
    }
    if (valueFormat === ValueFormat.stars) {
      return toStars(Number(value));
    }
  }
  return value;
}

/**
 * Combine the component with a set of content and generate a TemplateResult
 * @param {KeyFact} args - content to configure component
 * @returns {TemplateResult} - generated result
 */
export const generateHTML = (args: KeyFact): TemplateResult => html`
  <pop-key-fact-component
    data-variant="${args?.variant}"
    data-title="${args?.title}"
    data-content="${args?.value}"
    data-sub-content="${args?.subContent}"
    data-subtitle="${args?.subtitle}"
    data-tooltip="${args?.tooltip}"
    data-as-of-date="${args?.asOfDate}"
    data-value-format="${args?.valueFormat}"
    data-disclaimer-code="${args?.disclaimerCode}"
  ></pop-key-fact-component>
`;
